<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >促销优惠&市场活动</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/ShopIndex' }"
          >市场活动管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>活动banner</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <!-- <router-link to="/ShopIndex/addShop"></router-link> -->
          <p class="flex-rowl" @click="handleGo('', 'shopBannerDetail')">
            <i class="iconfont icon-xinzeng"></i> 新增
          </p>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="关键词查找"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="baseUrl + item.banner" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      活动：<span>{{ item.actidstr }}</span>
                    </p>
                    <p>
                      商品：<span>{{ item.goodsid }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      奖项等级：<span>{{ item.levelid }}</span>
                    </p>
                    <p>
                      排序：<span>{{ item.sortno }}</span>
                    </p>
                  </div>
                </div>
                <div class="operation_box flex-colt">
                  <div class="editBtn" @click="handleGo(item.id, 'shopBannerDetail')">
                    活动banner管理
                  </div>
                </div>
              </div>
            </div>
            <div class="shop_more"></div>
          </div>
        </template>
        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->
  </div>
</template>

<script>
import { getMenuAuthTwo, encryptstringadd, encryptstringview } from "../../api/api";
import { getActivityBannerList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "shopBanner",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      isShow: false,
      loading: false,
      listTotal: 0,
      dataList: [],
      params: {
        keyword: "",
        actid: '',  // 活动id
      },

      dataItem: "", // 单个商品
      shopPopupImg: "",
      
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.getMenuAuthTwo();
    
    let { routerList, OPENID, USERINFO, menuItem } = this.$store.state;
    let { name } = this.$route;
    this.roleId = USERINFO.roleid;
    this.menuItem = menuItem;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.actid = id
        this.initData();
      } else {
        this.$router.back();
      }
    },

    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },
    handleSearch() {
      this.params.pageindex = 1;
      this.initData();
    },
    initData() {
      let { params } = this;
      this.loading = true;
      getActivityBannerList(params).then((res) => {
        this.listTotal = res.total;
        this.dataList = res.list;
        this.loading = false;
      });
    },

    handleGo(id, name) {
      if (id == "") {
        this.encryptstringadd(name, {id: '', actid: this.params.actid});
      } else {
        this.encryptstringadd(name, { id, actid: this.params.actid });
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          })
          // window.open(this.$router.resolve({ name, params }).href, "_blank");
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .main_container {
    .screen_wrap {
      font-size: 14px;
      margin-right: 30px;
      .txt {
        cursor: pointer;
        &.active {
          font-size: 16px;
          color: red;
        }
        &:nth-child(2) {
          margin: 0 20px;
        }
      }
    }
  }
  .list_wrap {
    height: 59vh;
    .pic_box {
      width: 80px;
      height: 80px;
    }
  }
}
</style>